import { createFileRoute } from '@tanstack/react-router'
import { InterventionsPage } from '../../../components/InterventionsPage'

export const Route = createFileRoute('/$org/interventions/')({
  component: Interventions,
  validateSearch: (search: Record<string, unknown>): { kind: string | undefined; status: string | undefined; contract_uid?: string; asset_uid?: string } => {
    return {
      kind: search.kind ? String(search.kind) : undefined,
      status: search.status ? String(search.status) : undefined,
      contract_uid: search.contract_uid ? String(search.contract_uid) : undefined,
      asset_uid: search.asset_uid ? String(search.asset_uid) : undefined,
    }
  },
})

function Interventions() {
  return <InterventionsPage />
}
